<script setup lang="ts">
import { computed } from "vue";
import DRBtn from "./DRBtn.vue";
import DRBtnIcon from "./DRBtnIcon.vue";

const props = defineProps<{
  selectMode: boolean;
  selectedIds: number[];
  itemsIds: number[];
}>();

const emits = defineEmits<{
  (e: "selectAll", value: boolean | undefined | string | number): void;
  (e: "update:selectMode", value: boolean): void;
}>();

const itemsCount = computed(() => {
  return props.itemsIds.length;
});

const selectedCount = computed(() => {
  return props.selectedIds.length;
});

const isAllSelected = computed(() => {
  return itemsCount.value === selectedCount.value;
});

const hasSelected = computed(() => {
  return selectedCount.value > 0;
});

const isIndeterminate = computed(() => {
  return hasSelected.value && !isAllSelected.value;
});

const close = () => {
  emits("update:selectMode", false);
  emits("selectAll", false);
};
</script>

<template>
  <div v-if="!selectedIds?.length && !selectMode">
    <DRBtn
      variant="flat"
      :label="$t('select')"
      icon="bi-ui-checks-grid"
      @click="emits('update:selectMode', true)"
    />
  </div>
  <div
    v-else
    class="round bordered ps-3 py-1 pe-2 d-flex align-items-center justify-content-between gap-3"
  >
    <div>
      <el-checkbox
        color="info"
        v-model="isAllSelected"
        :indeterminate="isIndeterminate"
        @change="emits('selectAll', $event)"
        :label="`${$t('selectAll')} (${selectedCount || 0} / ${itemsCount})`"
      />
    </div>
    <template v-if="hasSelected">
      <slot name="actions"></slot>
    </template>
    <div>
      <DRBtnIcon @click="close" icon="bi-x-lg" :size="25" variant="flat" />
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
